<template lang="pug">
filter-detail-container(:title="title" @back="back" @save="save" @clear="clear" :saveMode="false")
  template(v-slot:body)
    .pa-6
      template(v-if="type !== 'phone'" )
        yc-text-field(label="All of these words" v-model="nameAll" hide-details="auto")
        .ma-2.text-xs.primary400--text Example: Ismail Adam - contains "Ismail" or "Adam" or both
      yc-text-field.mt-6(label="This exact phrase" v-model="nameExact" hide-details="auto")
      .ma-2.text-xs.primary400--text Example: Ahmad Adam - contains the exact phrase "Ahmad Adam"
      yc-text-field.mt-6(label="None of these words" v-model="nameNone" hide-details="auto")
      .ma-2.text-xs.primary400--text Example: Ismail Adam - does not contains "Ismail" and does not contain "Adam"
</template>

<script>
import FilterDetailContainer from '@/components/connect/FilterDetailContainer.vue'

export default {
  components: { FilterDetailContainer },
  props: {
    type: {
      type: String,
    },
    filter: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data: () => ({
    nameAll: '',
    nameExact: '',
    nameNone: ''
  }),
  computed: {
    title() {
      return `Filter ${this.$options.filters.capitalize(this.type)}`
    }
  },
  created() {
    this.nameAll = this.filter.all || ''
    this.nameExact = this.filter.exact || ''
    this.nameNone = this.filter.none || ''
  },
  methods: {
    save() {
      const filter = {
        all: this.nameAll,
        exact: this.nameExact,
        none: this.nameNone
      }
      this.$emit('update:filter', filter)
      this.back()
    },
    back() {
      this.$emit('onBack')
    },
    clear() {
      this.nameAll = ''
      this.nameExact = ''
      this.nameNone = ''
      const filter = {
        all: this.nameAll,
        exact: this.nameExact,
        none: this.nameNone
      }
      this.$emit('update:filter', filter)
    }
  }
}
</script>